<template>
  <div absolute class="text-center">
    <v-card-text>
      <ul>
        <li v-for="(item, index) in items.footerLanguages" :key="index" class="list-inline-item">
          <a class="cursor-point" @click="openItem(index)">{{
            item.title.content
          }}</a>
          <b-modal :id="'modal-' + index" :title="item.title.content" centered hide-header-close ok-only size="xl">
            <p v-html="item.content.content"></p>
          </b-modal>
        </li>
      </ul>
    </v-card-text>
    <v-card-text>
      <ul>
        <li class="list-inline-item" @click="goToStatus">
          <a href="#">Estado de los sistemas</a>
        </li>
      </ul>
    </v-card-text>
  </div>
</template>
<script>
import footerService from "../../../services/footer";

export default {
  name: "FooterSign",
  data() {
    return {
      items: [],
    };
  },
  mounted() {
    this.getAll();
  },
  methods: {
    goToStatus(){

      window.open("https://status.cita.io/status/pro", "_blank");

    },
    openByTitle(title) {
      let self = this;

      if (
        this.items &&
        this.items.footerLanguages &&
        this.items.footerLanguages.length !== 0
      ) {
        this.items.footerLanguages.forEach(function (valor, indice, array) {
          if (valor.title.content === title) {
            self.$bvModal.show("modal-" + valor.content.id);
          }
        });
      }
    },
    openItem(id) {
      this.$bvModal.show("modal-" + id);
    },
    getAll() {
      let self = this;

      this.$awn.asyncBlock(
        footerService.getAllPublic(),
        (response) => {
          if (response) {
            self.items = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "footerService.getAllPublic",
            module: "component-xray-footerSign",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null,
          });
        },
        " "
      );
    },
  },
};
</script>
